import styled from 'styled-components';

import { FileFormatInfo, FileColumn } from 'common/components/alchemy/FileInput/FileFormatInfo';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const Container = styled.div`
  margin: 0 24px 0;
  width: 100%;
  align-self: center;
`;

const OVERRIDE_REASONS = [
  'PROMOTION',
  'HOLIDAY',
  'MARKDOWN',
  'STORE_CLOSE',
  'SEASONAL_SELECTION',
  'ANNUAL_EVENT',
  'BASELINE_CORRECTION',
  'FREE_DELIVERY_CAMPAIGN',
  'MARKETING_CAMPAIGN',
  'OTHER',
  'LOST_SALES_CORRECTION',
] as const;

const overrideReasonValues = OVERRIDE_REASONS.join(', ');

const OverrideFileFormat = () => {
  const format = useFormatMessage();

  const columns: FileColumn[] = [
    {
      name: 'Product Code',
      required: false,
      topInfo: format('forecasting.upload_overrides_one_code_should_be_used'),
      footnote: format('forecasting.product_code_footnote'),
    },
    {
      name: 'External Product Code',
      info: format('inventory_replenishment.external_product_code_info'),
      footnote: format('forecasting.see_above'),
      separator: true,
    },
    {
      name: 'Venue Code',
      required: true,
      separator: true,
    },
    {
      name: 'Override Type',
      required: true,
      info: 'PERCENTAGE, VALUE, REPLACE',
    },
    {
      name: 'Override Reason',
      required: true,
      footnote: format('forecasting.override_reasons', { values: overrideReasonValues }),
    },
    {
      name: 'Override Name',
      required: true,
      separator: true,
    },
    {
      name: 'Create a new column for each new date.',
      info: 'YYYY-MM-DD',
      topInfo: format('forecasting.override_baseline_by_date'),
    },
  ];

  return (
    <Container>
      <FileFormatInfo columns={columns} />
    </Container>
  );
};

export default OverrideFileFormat;
